import { useQuery } from "@tanstack/react-query";
import api from "@/dealership/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const NONE = "__none__";

export function vehicleLabel(v) {
  const base = `${v.year || ""} ${v.make || ""} ${v.model || ""}${v.trim ? " " + v.trim : ""}`.trim();
  const tag = v.stock_number || v.vin;
  return tag ? `${base} · ${tag}` : base;
}

// Dropdown of inventory vehicles. Value is a plain string (the vehicle label),
// so it stays compatible with free-text fields. An existing custom/imported
// value that isn't in inventory is preserved as a "(current)" option.
export default function VehicleSelect({ value, onChange, testId, placeholder = "Select a vehicle" }) {
  const { data: vehicles = [] } = useQuery({
    queryKey: ["inventory"],
    queryFn: async () => (await api.get("/inventory")).data,
  });

  const labels = vehicles.map(vehicleLabel);
  const hasCustom = value && !labels.includes(value);

  return (
    <Select value={value || undefined} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>— None —</SelectItem>
        {hasCustom && <SelectItem value={value}>{value} (current)</SelectItem>}
        {vehicles.map((v) => {
          const label = vehicleLabel(v);
          return <SelectItem key={v.id} value={label}>{label}</SelectItem>;
        })}
      </SelectContent>
    </Select>
  );
}
